export default __webpack_public_path__ + "static/media/download-referral.19e52be6.svg";